module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/id_tohoku-bdc5391436f12b61e1a27991172f6725.jpg";